import React from 'react'
import { Button } from 'reactstrap'

export const AnalysisRequestNotifyButton = ({disabled}) => {
    return (
        <Button disabled={disabled} className='btn btn-success rounded-3 d-flex align-items-center py-1'>
            <span className="mdi mdi-18px mdi-email-outline me-2"></span>Notificar
        </Button>
    )
}
